import { plainToInstance } from 'class-transformer'
import i18n from 'vue-i18n'

import { SocketNames } from '../../../../../components'
import ChannelsInfoHelper from '../../../../Helpers/ChannelsInfoHelper'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import CheckSubscriptionSampleNode from '../ui/SampleNode/CheckSubscriptionSampleNode.vue'
import CheckSubscriptionSidebar from '../ui/Sidebar/CheckSubscriptionSidebar.vue'
import { CheckSubscriptionNodeProps } from './types'

export default class CheckSubscriptionNodeBuilder extends CustomNodeComponent {
  sidebarComponent = CheckSubscriptionSidebar

  constructor(i18n: i18n, nodeProps: CheckSubscriptionNodeProps) {
    super(CheckSubscriptionSampleNode, CheckSubscriptionNode, NodeTypes.CheckSubscription, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
    return {
      data: plainToInstance(CheckSubscriptionNodeData, {
        type: NodeTypes.CheckSubscription,
        targets: [],
        time: 0,
        success_output: CustomNode.LastSocketId += 1,
        fail_output: CustomNode.LastSocketId += 1,
      }),
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class CheckSubscriptionNode extends CustomNode {
  data: CheckSubscriptionNodeData

  declare nodeProps: CheckSubscriptionNodeProps

  constructor(name: NodeTypes.CheckSubscription, model: BaseNodeModel, nodeProps: CheckSubscriptionNodeProps) {
    super(name, model, nodeProps)

    if (model.data instanceof CheckSubscriptionNodeData) {
      model.data.targets = model.data.targets.filter(t => !!t)

      model.data.targets.forEach(t => {
        const channel = ChannelsInfoHelper.GetChannel(t!.toString())

        if (!channel?.status) {
          this.errorChannelInfo.push(t!.toString())
        }
      })

      this.data = model.data

      this.socketActions.createOutput(model.data.success_output, SocketNames.Success)
      this.socketActions.createOutput(model.data.fail_output, SocketNames.Fail)
    } else {
      throw new Error('To node come unknown data')
    }
  }

  errorChannelInfo: Array<string> = []

  setTime(time: number): void {
    this.data.time = time
  }

  setTarget(id: number): void {
    this.data.targets.push(id)
  }

  removeTarget(id: number): void {
    this.data.targets = this.data.targets.filter(t => t !== id)
  }

  setErrorChannelInfo(value: string): void {
    if (!this.errorChannelInfo.includes(value)) {
      this.errorChannelInfo.push(value)
    }
  }

  removeErrorTarget(value: string): void {
    const index = this.errorChannelInfo.findIndex((t) => t === value)
    const numIndex = Number.parseInt(value)

    if (index !== -1) {
      this.errorChannelInfo.splice(index, 1)
      this.removeTarget(numIndex)
    }
  }
}

export class CheckSubscriptionNodeData extends BaseNodeModelData {
  declare type: NodeTypes.CheckSubscription
  targets!: Array<number | null>
  time!: number
  success_output!: number
  fail_output!: number
}
